export default "__VITE_ASSET__edbd160d__"